import { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

interface LightboxProps {
  image: string;
  title: string;
  location: string;
  onClose: () => void;
  onPrevious: () => void;
  onNext: () => void;
}

const Lightbox = ({ image, title, location, onClose, onPrevious, onNext }: LightboxProps) => {
  // Add event listener for Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrevious();
      if (e.key === "ArrowRight") onNext();
    };

    document.addEventListener("keydown", handleKeyDown);
    // Prevent scrolling when lightbox is open
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrevious, onNext]);

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div className="relative w-full max-w-4xl mx-4" onClick={(e) => e.stopPropagation()}>
        <button 
          className="absolute top-4 right-4 text-white text-3xl z-10 hover:text-gray-300 transition-colors"
          onClick={onClose}
          aria-label="Close"
        >
          <FaTimes />
        </button>
        
        <img 
          src={image} 
          alt={title} 
          className="max-w-full max-h-[85vh] mx-auto"
        />
        
        <div className="text-white text-center mt-4">
          <h3 className="text-xl font-heading font-bold">{title}</h3>
          <p className="text-sm opacity-80">{location}</p>
        </div>
        
        <div className="flex justify-between mt-4">
          <button 
            className="text-white text-4xl hover:text-gray-300 transition-colors"
            onClick={onPrevious}
            aria-label="Previous"
          >
            &lsaquo;
          </button>
          <button 
            className="text-white text-4xl hover:text-gray-300 transition-colors"
            onClick={onNext}
            aria-label="Next"
          >
            &rsaquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Lightbox;
